import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "hooks/useFirebase";

/**
 * Whether Firebase has finished restoring the signed-in user.
 *
 * `auth.currentUser` is null for the first moments after a page load even when
 * a session exists, so a request fired on the first render goes out with an
 * empty bearer token and fails. Queries that run on mount — rather than in
 * response to something the teacher did — should wait on this before asking.
 *
 * @returns {boolean}
 */
export const useAuthReady = () => {
  const [ready, setReady] = useState(() => Boolean(auth.currentUser));

  useEffect(() => {
    if (ready) return undefined;
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) setReady(true);
    });
    return unsubscribe;
  }, [ready]);

  return ready;
};
